/**
 * Wire times carry the airport's own offset — `2026-10-13T04:45:00+05:30`.
 *
 * `new Date(iso).getHours()` resolves that to an instant and then re-expresses it
 * in whoever is reading: a viewer in Sydney, or the Node process during SSR,
 * sees a different departure time than the airport clock shows. So the fields are
 * read literally and the offset ignored, which is what legacy's
 * `dayjs(t, 'YYYY-MM-DDTHH:mm:ss')` does.
 *
 * Durations are the opposite case and must keep using instants — a layover that
 * crosses a timezone is only correct as elapsed time.
 */
const ISO_FIELDS = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/

/** `'04:45'` — the airport's wall clock, wherever it is read. */
export const parseAirportTime = (iso: string | undefined): string => {
  const fields = ISO_FIELDS.exec(iso ?? '')
  return fields ? `${fields[4]}:${fields[5]}` : ''
}

/**
 * A `Date` whose *local* fields spell the airport's wall clock, so weekday and
 * month names come out right. Only for formatting — it is not the real instant.
 */
export const airportDate = (iso: string | undefined): Date | null => {
  const fields = ISO_FIELDS.exec(iso ?? '')
  if (!fields) return null
  return new Date(Number(fields[1]), Number(fields[2]) - 1, Number(fields[3]), Number(fields[4]), Number(fields[5]))
}
